import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getIssueCount, getName } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import { getIssuesUrl } from '../../../../state/selectors.tsx';
import IssuesView from './view.tsx';

type OwnProps = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
	name: getName(state, ownProps.componentId),
	number: getIssueCount(state, ownProps.componentId),
	issuesUrl: getIssuesUrl(state, ownProps.componentId),
});

export default connect(mapStateToProps, {})(IssuesView);
